module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "1",
      "epub:type": "pagebreak",
      "id": "page1",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after"
  }, [_vm._v("When you find yourself on a London platform shouting into your mobile, ‘We haven’t got enough demons! Do you want me to order some more?’ as folk quietly edge away from you—you know you’re running a witchcraft shop.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after"
  }, [_vm._v("When one of your staff members believes herself to be Queen of the Fairies and tells all your suppliers of her new status as supernatural royalty—you know you’re running a witchcraft shop.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after"
  }, [_vm._v("When your customers think wormwood is for culinary purposes—you know you’re running a witchcraft shop.")]), _vm._v(" "), _c('p', {
    staticClass: "graphic-centred-quarter-page-fit"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Image1245.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("The Isle of Avalon, lost behind its mists, where Arthur was carried by three magical queens. Inis Witrin, the island of glass, ancient home of Christianity. Glastonbury, a little market town in Somerset. Whatever you call it, it’s been a centre of pilgrimage and miracles for most of its history. People have been coming here for over a thousand years, looking for—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something")]), _vm._v(". Looking for Christ. Looking for the goddess or the god. Looking for angels and fairies. Looking for solutions and answers.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In 2004, when I was 39, I had a particularly bad Christmas. Over the course of ten days, my aunt died, a cousin was operated on for breast cancer, my father had a stroke, my then-boyfriend dumped me and so did my American publisher. Furthermore, it was the second anniversary of the death of my long-term partner, also from cancer: he’d died of a brain tumour on Christmas Eve, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("So I did what a lot of people do. I came to Glastonbury, to get away from it all, to find some sort of healing. I went into the Goddess Temple, and there behind the altar was a representation of the Crone: the old bone woman of the heart of winter. It was too much, I told her: too much for me to cope with. And I gave my problems to her, like someone handing over a heavy piece of luggage.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Coming out of the Goddess Temple, I wandered around Glastonbury in the thin winter sunlight and found a little shop down an alley—like Diagon Alley in the Harry Potter novels. It was a little witchcraft shop, and standing in it was a big man who was kind enough to listen to all my woes. He gave me a meditation to do over Christmas, centred around blackthorn—the white-flowering, sloe-bearing purgative of the hedgerow. I did the meditation over Christmas, at my family’s house. In the New Year, suffering from a dreadful cold, I came back to Glastonbury and went to see the big man in the little shop (it hadn’t mysteriously vanished, by the way). He asked me out for a drink. We went to the George and Pilgrim hotel and talked about his bees, and that was that. Six years later, we’re still together (along with two dogs, three cats, a Shetland and the aforementioned bees). The little shop became too little and we moved to Benedict Street: it’s still there and it’s called Witchcraft Ltd. Two more shops followed it, the Magick Box and the Cat and Cauldron (known to the occult cognoscenti as the Mog and Bucket: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thank ")]), _vm._v("you for that, Jacquelyn in Lincoln).")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Meeting Trevor wasn’t the end of my problems. Fairy tales always have a dark aftermath. Over the next few years, we had more difficulties than many people experience in a lifetime. That was our Glastonbury Experience, of which more later. But somehow, we’re still sailing our little lifeboat through them all.")]), _vm._v(" "), _c('p', {
    staticClass: "graphic-centred-quarter-page-fit"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/Image1245.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("When I was with my late partner, Charles, we used to come to Glastonbury every year: he had old friends who ran the Assembly Rooms. Charles hated shopping and wasn’t all that keen on witchcraft, either (he was a Cabbalist: they don’t seem to shop much). ‘Welcome to bloody fairyland,’ he’d say, as we pulled into St John’s car park. So he would wait in the George and Pilgrim inn (700 years old and counting) while I rushed round the shops. There weren’t so many witchcraft shops then, but I still never had enough time to look at things properly and I always wished I could spend more time in a shop in Glastonbury.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Be careful what you wish for, the old wives always say.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("Sometimes, those old wives know what they’re talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "graphic-centred-full-page-fit"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "A cartoon of a person in a robe\n\nDescription automatically generated",
      "src": "image/Image1261.jpg"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "2",
      "epub:type": "pagebreak",
      "id": "page2",
      "role": "doc-pagebreak"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d11c88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DiaryofaWitchcraftShop.vue
// module id = 66
// module chunks = 0